import Input from "../../../components/Input";
import Checkbox from "../../../components/Checkbox";
import Link from "../../../components/Link";
import Card from "../../../components/Card";
import React from "react";
import {Company} from "../../../types/Subscription";
import {useTranslation} from "react-i18next";

type CompanyDataFormProps = {
    data: Partial<Company>;
    changeData: (data: Partial<Company>) => void;
    showAGBandDisclaimer?: boolean;
}

const CompanyDataForm: React.FC<CompanyDataFormProps> = (
    {
        data,
        changeData,
        showAGBandDisclaimer = true
    }
) => {
    const {t} = useTranslation(['settings'])

    return (
        <Card title={t("subscription.companyInformation")} classes={'my-6'}>
            <div className={'row'}>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.companyName")}
                        property={'company'}
                        value={data.company ?? ''}
                        onChange={(property, value) => changeData({company: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.firstName")}
                        property={'firstname'}
                        value={data.firstname ?? ''}
                        onChange={(property, value) => changeData({firstname: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.lastName")}
                        property={'lastname'}
                        value={data.lastname ?? ''}
                        onChange={(property, value) => changeData({lastname: value})}
                    />
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.streetNr")}
                        property={'street'}
                        value={data.street ?? ''}
                        onChange={(property, value) => changeData({street: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.postalCode")}
                        property={'zipcode'}
                        value={data.zipcode ?? ''}
                        onChange={(property, value) => changeData({zipcode: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.city")}
                        property={'city'}
                        value={data.city ?? ''}
                        onChange={(property, value) => changeData({city: value})}
                    />
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.additionalAddress")}
                        property={'additional'}
                        value={data.additional ?? ''}
                        onChange={(property, value) => changeData({additional: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={'USt-ID (optional))'}
                        property={'ust'}
                        value={data.ust ?? ''}
                        onChange={(property, value) => changeData({ust: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Input
                        type={'text'}
                        placeholder={t("subscription.telephone")}
                        property={'phone'}
                        value={data.phone ?? ''}
                        onChange={(property, value) => changeData({phone: value})}
                    />
                </div>
            </div>
            {showAGBandDisclaimer && <div className={'row'}>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Checkbox
                        property={'disclaimer'}
                        value={data.disclaimer ?? false}
                        label={
                            <>
                                {t("subscription.acceptThe")} <Link target={'_blank'} url={"https://jtl.medienagentur-dresden.net/agb/"}>
                                {t("subscription.generalTerms")}</Link>
                            </>
                        }
                        onChange={(property, value) => changeData({disclaimer: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                    <Checkbox
                        property={'agb'}
                        value={data.agb ?? false}
                        label={
                            <>
                            {t("subscription.acceptThe")} <Link target={'_blank'} url={"https://medienagentur-dresden.net/datenschutz/"}>
                                {t("subscription.privacyPolicy")}</Link>
                            </>
                        }
                        onChange={(property, value) => changeData({agb: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 col-xl-4 my-3'}>
                </div>
            </div>}
        </Card>
    )
}

export default CompanyDataForm
